// extracted by mini-css-extract-plugin
export default {"logoImage":"Logo__logoImage--2u8","logo":"Logo__logo--15M"};